export default __webpack_public_path__ + "static/media/E0DFD971-63C8-429C-8FC0-99ED0C2DC3EF_1_105_c.cc8ce83a.jpeg";